import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { GestionService } from "../../../../services/gestion.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'app-pd-new-edit',
    templateUrl: './new-edit.component.html'
})
export class PdNewEditComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();
    private _paisDenominacion;
    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();

    public _toDelete: any
    public _editable: boolean;

    public grupoEtiquetaIdCaja;
    public grupoEtiquetaIdPallet;

    public deleteModal = false;
    public marcasModal = false;

    public disabled: Subject<boolean> = new Subject();
    public disabledCaja: Subject<boolean> = new Subject();
    public disabledPallet: Subject<boolean> = new Subject();
    public randomId = Math.random();

    public pestanaActiva = new Array<number>();
    public dropdownInfo: number;
    public dropdownSection: number;

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                this.disabled.next(true);
                this.disabledCaja.next(false);
                this.disabledPallet.next(false);
            } else {
                this.newEditForm.disable();
                this.newEditForm.patchValue(this.paisDenominacion);
                this.newEditForm.patchValue({
                    pais: this.paises.find(x => x.id === this.paisDenominacion.paisId),
                });
                this.newEditForm.get('etiquetaCajaConfeccionPalletRequerida').disable();
                this.disabled.next(true);
                this.disabledCaja.next(true);
                this.disabledPallet.next(true);
                this.newEditForm.get('grupoEtiquetasCaja')
                    .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === 0));
                this.newEditForm.get('grupoEtiquetasPallet')
                    .patchValue(this.allGrupoEtiquetasPallet[0]);
                for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                    if (grupoEtiquetaCaja.grupoEtiquetaId) {
                        this.newEditForm.get('grupoEtiquetasCaja')
                            .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                        this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                    }
                }
                for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                    if (grupoEtiquetaPallet.grupoEtiquetaId) {
                        this.newEditForm.get('grupoEtiquetasPallet')
                            .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                        this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                    }
                }
            }
        }
    }

    @Input() allGrupoEtiquetasCaja;
    @Input() allGrupoEtiquetasPallet;
    @Input() paisDenominacion?;
    @Input() paisId;
    @Input() denominacionId;
    @Input() grupoEtiquetasCaja;
    @Input() grupoEtiquetasPallet;
    @Input() index;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _gestionService: GestionService,
        private readonly _dataProvider: DataProvider
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            pais: ['', Validators.required],
            grupoEtiquetasCaja: [{ value: '', disabled: !this.editable }, Validators.required],
            grupoEtiquetasPallet: [{ value: '', disabled: !this.editable }, Validators.required],
            gestionIncidencias: [false],
            permisoLecturaDataMatrixPublica: [false],
            permisoConfeccionPallet: [false],
            forzarImprimirDestino: [false],
            etiquetaCajaConfeccionPalletRequerida: [{ value: false, disabled: true}],
            modoEtiquetas: [false],
            modoCertificado: [false]
        });

        if (this.paisDenominacion) {
            this.newEditForm.patchValue(this.paisDenominacion);
            this.newEditForm.patchValue({
                pais: this.paises.find(x => x.id === this.paisDenominacion.paisId),
            });
            this.newEditForm.disable();
            this.disabled.next(true);
            this.disabledCaja.next(true);
            this.disabledPallet.next(true);
        }

        if (this.grupoEtiquetasCaja) {
            this.newEditForm.get('grupoEtiquetasCaja')
                .patchValue(this.allGrupoEtiquetasCaja[0]);
            for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                if (grupoEtiquetaCaja.grupoEtiquetaId) {
                    this.newEditForm.get('grupoEtiquetasCaja')
                        .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                    this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                }
            }
        } else {
            this.newEditForm.get('grupoEtiquetasCaja')
                .patchValue(this.allGrupoEtiquetasCaja[0]);
        }

        if (this.grupoEtiquetasPallet) {
            this.newEditForm.get('grupoEtiquetasPallet')
                .patchValue(this.allGrupoEtiquetasPallet[0]);
            for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                if (grupoEtiquetaPallet.grupoEtiquetaId) {
                    this.newEditForm.get('grupoEtiquetasPallet')
                        .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                    this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                }
            }
        } else {
            this.newEditForm.get('grupoEtiquetasPallet')
                .patchValue(this.allGrupoEtiquetasPallet[0]);
        }

        this.newEditForm.get('permisoConfeccionPallet').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((permiso) => {
            if (permiso === true) {
               this.newEditForm.get('etiquetaCajaConfeccionPalletRequerida').enable();
            } else {
                this.newEditForm.get('etiquetaCajaConfeccionPalletRequerida').reset();
                this.newEditForm.get('etiquetaCajaConfeccionPalletRequerida').disable();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.newEditForm.get('pais').enabled) {
                this.newEditForm.get('pais').patchValue(this._dataProvider.paises[0]);
                this.newEditForm.get('pais').disable();
            }
        }
        return this._dataProvider.paises;
    }

    public save() {
        this.checkForm();

        if (!this.newEditForm.get("modoCertificado")?.value && !this.newEditForm.get("modoEtiquetas")?.value) {
            this.showError = true;
            this.mensajes.push({
                class: "error",
                message: "global.error.modoCertEtiq",
            });
            return;
        }

        if (this.newEditForm.valid && !this.paisDenominacion) {
            this._paisDenominacion = {
                paisId: this.newEditForm.get('pais').value.id,
                denominacionId: this.denominacionId,
                gestionIncidencias: this.newEditForm.get('gestionIncidencias').value ?
                    this.newEditForm.get('gestionIncidencias').value : false,
                permisoLecturaDataMatrixPublica: this.newEditForm.get('permisoLecturaDataMatrixPublica').value ?
                    this.newEditForm.get('permisoLecturaDataMatrixPublica').value : false,
                permisoConfeccionPallet: this.newEditForm.get('permisoConfeccionPallet').value ?
                    this.newEditForm.get('permisoConfeccionPallet').value : false,
                forzarImprimirDestino: this.newEditForm.get('forzarImprimirDestino').value ?
                    this.newEditForm.get('forzarImprimirDestino').value : false,
                etiquetaCajaConfeccionPalletRequerida: this.newEditForm.get('etiquetaCajaConfeccionPalletRequerida').value ?
                this.newEditForm.get('etiquetaCajaConfeccionPalletRequerida').value : false,
                modoEtiquetas: this.newEditForm.get('modoEtiquetas').value ?
                    this.newEditForm.get('modoEtiquetas').value : false,
                modoCertificado: this.newEditForm.get('modoCertificado').value ?
                    this.newEditForm.get('modoCertificado').value : false,
            };
            this._spinnerService.showSpinner();
            this._gestionService.createPaisDenominacion(this._paisDenominacion).toPromise().finally(() => {
            }).then((resp) => {
                if (resp) {
                    this._editable = false;
                    const promises: Promise<any>[] = [];
                    promises.push(
                        this.updateGrupoEtiquetasCaja(resp)
                    );
                    promises.push(
                        this.updateGrupoEtiquetasPallet(resp)
                    );
                    Promise.all(promises).then(
                        () => {
                            this.refresh.emit(true);
                            this.newEditForm.disable();
                            this.disabledCaja.next(true);
                            this.disabledPallet.next(true);
                            this.disabled.next(true);
                            this.pushMessage.emit('global.success.itemCreated');
                            return true;
                        }, (error) => {
                            this.pushMessage.emit('global.error.noResponse');
                            console.log('Promise rejected with ' + JSON.stringify(error));
                        }
                    ).catch(e => console.log(e));
                }
            },
                (error) => {
                    this._spinnerService.hideSpinner();
                    if (error.status === 420) {
                        switch (error.error.ApiErrorCode) {
                            case 6059:
                                this.pushMessage.emit('ApiErrors.PDYaExiste');
                                break;
                            default:
                                this.pushMessage.emit('ApiErrors.serverError');
                                break;
                        }
                    } else {
                        this.pushMessage.emit('ApiErrors.serverError');
                    }
                });
        } else if (this.newEditForm.valid && this.paisDenominacion) {
            this._paisDenominacion = {
                paisId: this.newEditForm.get('pais').value.id,
                denominacionId: this.paisDenominacion.denominacionId,
                gestionIncidencias: this.newEditForm.get('gestionIncidencias').value ?
                    this.newEditForm.get('gestionIncidencias').value : false,
                permisoLecturaDataMatrixPublica: this.newEditForm.get('permisoLecturaDataMatrixPublica').value ?
                    this.newEditForm.get('permisoLecturaDataMatrixPublica').value : false,
                permisoConfeccionPallet: this.newEditForm.get('permisoConfeccionPallet').value ?
                    this.newEditForm.get('permisoConfeccionPallet').value : false,
                forzarImprimirDestino: this.newEditForm.get('forzarImprimirDestino').value ?
                    this.newEditForm.get('forzarImprimirDestino').value : false,
                etiquetaCajaConfeccionPalletRequerida: this.newEditForm.get('etiquetaCajaConfeccionPalletRequerida').value ?
                    this.newEditForm.get('etiquetaCajaConfeccionPalletRequerida').value : false,
                modoEtiquetas: this.newEditForm.get('modoEtiquetas').value ?
                    this.newEditForm.get('modoEtiquetas').value : false,
                modoCertificado: this.newEditForm.get('modoCertificado').value ?
                    this.newEditForm.get('modoCertificado').value : false,
            };
            this._spinnerService.showSpinner();
            this._gestionService.updatePaisDenominacion(this._paisDenominacion).toPromise().finally(() => {
            }).then(
                (resp) => {
                    const promises: Promise<any>[] = [];
                    promises.push(
                        this.updateGrupoEtiquetasCaja(resp)
                    );
                    promises.push(
                        this.updateGrupoEtiquetasPallet(resp)
                    );
                    Promise.all(promises).then(
                        () => {
                            this.refresh.emit(true);
                            this.newEditForm.disable();
                            this.disabledCaja.next(true);
                            this.disabledPallet.next(true);
                            this.disabled.next(true);
                            this.pushMessage.emit('global.success.itemUpdated');
                            return true;
                        }, (error) => {
                            this.pushMessage.emit('global.error.noResponse');
                            console.log('Promise rejected with ' + JSON.stringify(error));
                        }
                    ).catch(e => console.log(e));
                },
            );
        }
    }

    public updateGrupoEtiquetasCaja(resp?): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.newEditForm.get('grupoEtiquetasCaja').value.id !== 0) {
                const updateGrupoEtiquetaCaja = {
                    paisId: resp ? resp.paisId : this.paisDenominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.paisDenominacion.denominacionId,
                    grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasCaja').value.id
                };
                this._gestionService.updateGruposEtiquetaPaisDenominacion(updateGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else if (this.newEditForm.get('grupoEtiquetasCaja').value.id === 0 && this.grupoEtiquetaIdCaja) {
                const deleteGrupoEtiquetaCaja = {
                    paisId: resp ? resp.paisId : this.paisDenominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.paisDenominacion.denominacionId,
                    grupoEtiquetaId: this.grupoEtiquetaIdCaja
                };
                this._gestionService.deleteGruposEtiquetaPaisDenominacion(deleteGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else {
                setTimeout(resolve, 1);
            }
        });
    }

    public updateGrupoEtiquetasPallet(resp?): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.newEditForm.get('grupoEtiquetasPallet').value.id !== 0) {
                const updateGrupoEtiquetaPallet = {
                    paisId: resp ? resp.paisId : this.paisDenominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.paisDenominacion.denominacionId,
                    grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasPallet').value.id
                };
                this._gestionService.updateGruposEtiquetaPaisDenominacion(updateGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else if (this.newEditForm.get('grupoEtiquetasPallet').value.id === 0 && this.grupoEtiquetaIdPallet) {
                const deleteGrupoEtiquetaPallet = {
                    paisId: resp ? resp.paisId : this.paisDenominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.paisDenominacion.denominacionId,
                    grupoEtiquetaId: this.grupoEtiquetaIdPallet
                };
                this._gestionService.deleteGruposEtiquetaPaisDenominacion(deleteGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else {
                setTimeout(resolve, 1);
            }
        });
    }

    public cancel() {
        this.newEditForm.reset();
        this.editableChanged.emit(false);
    }

    public closeModal() {
        this.marcasModal = false;
        this.deleteModal = false;
        this._toDelete = '';
    }

    public edit(paisDenominacion) {
        this.newEditForm.get('gestionIncidencias').enable();
        this.newEditForm.get('permisoLecturaDataMatrixPublica').enable();
        this.newEditForm.get('permisoConfeccionPallet').enable();
        this.newEditForm.get('modoEtiquetas').enable();
        this.newEditForm.get('modoCertificado').enable();
        this.newEditForm.get('forzarImprimirDestino').enable();
        this.newEditForm.get('grupoEtiquetasCaja').enable();
        this.newEditForm.get('grupoEtiquetasPallet').enable();
        this.disabled.next(true);
        this.disabledCaja.next(false);
        this.disabledPallet.next(false);
        this.editableChanged.emit(paisDenominacion);
    }

    public openMarcas(paisDenominacion) {
        this.paisId = paisDenominacion.paisId;
        this.denominacionId = paisDenominacion.denominacionId;
        this.marcasModal = true;
    }

    public askDelete(paisDenominacion) {
        this.paisId = paisDenominacion.paisId;
        this.denominacionId = paisDenominacion.denominacionId;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._gestionService.deletePaisDenominacion(this.paisId, this.denominacionId).toPromise().finally(() => {
        }).then(() => {
            this.closeModal();
            this.refresh.emit(true);
            this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({
                class: "error",
                message: "global.error.required",
            });
        }
    }

    public toRefresh(value) {
        this.marcasModal = false;
        if(value) this.refresh.emit(true);
    }

    public showMarcas() {
        this.marcasModal = true;
    }

    public showMarcasPaisDenominacion(index) {
        this.pestanaActiva[index] = 1;
    }
}
